const switchList = [{ id: 'New-Jersey', name: 'Enyx-NJ' },
  { id: 'Chicago', name: 'Enyx-Chicago' },
  { id: 'Toronto', name: 'Enyx-Toronto' }
];
export default switchList;
